import React from "react";
import icon from "./search.svg";
import css from "../AutoSamplete.module.css";

function InputField({ textInput, handleTextInput }) {
  return (
    <div className={css.inputdiv}>
      <input
        onChange={handleTextInput}
        type="text"
        value={textInput}
        placeholder="Enter search..."
        className={css.inputfield}
      ></input>
      <img src={icon} alt="search icon" className={css.inputsearchpic} />
    </div>
  );
}

export default InputField;
